<apx-chart
  [series]="series"
  [colors]="colors"
  [fill]="fill"
  [stroke]="stroke"
  [chart]="options.chart"
  [dataLabels]="options.dataLabels"
  [grid]="options.grid"
  [legend]="options.legend"
  [markers]="options.markers"
  [tooltip]="options.tooltip"
  [xaxis]="options.xaxis"
  [yaxis]="options.yaxis"
  [responsive]="options.responsive"
></apx-chart>
